import React from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

function Anchor({ className, style, children, href = '#', role, ariaLabel, tabIndex, 'data-uk-scroll': dataUkScroll, 'data-uk-slider-item': dataUkSliderItem, ...rest }) {
    return (
        // The only allowed <a href="#"/> in this project.
        // eslint-disable-next-line react/forbid-elements
        <a href={href} style={style} className={className} data-uk-scroll={dataUkScroll} data-uk-slider-item={dataUkSliderItem} {...rest} role={role} aria-label={ariaLabel} tabIndex={tabIndex}>
            {children}
        </a>
    );
}

Anchor.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    style: PropTypes.object,
    href: PropTypes.string,
    role: PropTypes.string,
    ariaLabel: PropTypes.string,
    tabIndex: PropTypes.string,
    'data-uk-scroll': PropTypes.string,
    'data-uk-slider-item': PropTypes.string,
};

Anchor.propTypes = exact(Anchor.propTypes);

export default Anchor;
